import type { AgentEvent } from "./types";

/** Only final_answer establishes accepted output. Turn text can contain
 *  drafts that are subsequently rejected, truncated, or revised. */
export function getFinalBuildAnswer(events: AgentEvent[]): string | null {
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i]!;
    if (event.type === "final_answer") return event.answer;
  }
  return null;
}
